import type { ReactNode } from 'react';
import type { BoxProps } from '@material-ui/core';
import { Box, Typography } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import contentStyles from 'styles/contentBox';

interface ContentBoxI extends BoxProps {
  title?: string;
  children?: ReactNode | ReactNode[];
}

const ContentBox: FunctionComponent<ContentBoxI> = ({
  title,
  children,
  ...props
}: ContentBoxI) => {
  const classes = contentStyles();

  return (
    <Box className={classes.contentBox} {...props}>
      {title && <Typography>{title}</Typography>}
      {Array.isArray(children) ? children.map(item => item) : children}
    </Box>
  );
};

export default ContentBox;

ContentBox.defaultProps = {
  title: undefined,
  children: undefined
};
